import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import { INCIDENTS_LIST } from '@/utils/constants';
import {
  SEARCH_PARAM_INCIDENT_SEARCH,
  SEARCH_PARAM_STATION_ID,
  SEARCH_PARAM_STATION_SEARCH,
} from '@/utils/constants/queries';

const useStationSearch = (viewType: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const prevStationIdRef = useRef<string | null>(null);

  const paramStationId = searchParams.get(SEARCH_PARAM_STATION_ID);

  const isIncidentsView = viewType === INCIDENTS_LIST;
  const activeParam = isIncidentsView ? SEARCH_PARAM_INCIDENT_SEARCH : SEARCH_PARAM_STATION_SEARCH;
  const activeSearchKey = searchParams.get(activeParam) ?? '';

  const setActiveSearchKey = (value: string) => {
    const current = searchParams.get(activeParam) ?? '';

    if (value === current) {
      return;
    }

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);

        if (value) {
          next.set(activeParam, value);
        } else {
          if (isIncidentsView) {
            next.delete(SEARCH_PARAM_INCIDENT_SEARCH);
          } else {
            next.delete(SEARCH_PARAM_STATION_SEARCH);
            next.delete(SEARCH_PARAM_INCIDENT_SEARCH);
          }
        }

        return next;
      },
      { replace: true }
    );
  };

  useEffect(() => {
    if (!paramStationId) {
      return;
    }

    if (paramStationId === prevStationIdRef.current) {
      return;
    }

    prevStationIdRef.current = paramStationId;

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(SEARCH_PARAM_INCIDENT_SEARCH);

        return next;
      },
      { replace: true }
    );
  }, [paramStationId]);

  return { activeSearchKey, setActiveSearchKey };
};

export default useStationSearch;
